import React from "react";
import clsx from "clsx";


interface ButtonProps {
  variant?: "primary" | "secondary" | "tertiary";
  size?: "large" | "small" | "medium" | "extra-large";
  label?: string;
  onClick?: (arg: any) => void;
  type?: "button" | "submit";
  icon?: React.ReactNode;
  width?: number | string;
  height?: number | string;
  loading?: boolean;
  disabled?: boolean;
  textColor?: string;
  capitalized?: boolean;
  additionalClassname?: any;
  iconPosition?: "left" | "right";
  children?: React.ReactNode;
  iconSpace?: number;
  noRounded?: boolean;
  backgroundColor?: string;
}

const Button: React.FC<ButtonProps> = ({
  variant,
  label,
  onClick = () => {},
  type = "button",
  icon,
  width,
  height,
  loading = false,
  disabled = false,
  textColor,
  capitalized,
  additionalClassname,
  size = "large",
  iconPosition = "left",
  iconSpace = 16,
  noRounded,
  backgroundColor
}) => {
  const computedStyle = () => {
    const style: {
      width?: string;
      height?: string;
      color?: string;
      backgroundColor?: string;
    } = {};

    if (width) {
      style.width = `${width}`;
    }

    if (height) {
      style.height = `${height}`;
    }

    if (textColor) {
      style.color = textColor;
    }

    if (backgroundColor) {
      style.backgroundColor = backgroundColor;
    }

    return style;
  };

  return (
    <button
      className={clsx({
        "flex gap-2 items-center text-sm justify-center rounded-[80px] font-[500] w-full":
          true,
        "rounded-[8px]": noRounded === true,
        "bg-red-600 text-[#fff]": variant === "primary",
        "bg-[#fdfdfd]": variant && ["secondary", "tertiary"].includes(variant),
        "text-red-600 border-[1px] border-solid border-red-600":
          variant === "secondary",
        "border-[rgba(51, 51, 51, 0.1)]": variant === "tertiary",
        "opacity-50 cursor-not-allowed": disabled,
        "!w-[260px] h-[40px]": size === "large",
        "!w-[130px] h-[40px]": size === "medium",
        "!w-[90px] h-[32px]": size === "small",
        "w-full h-[50px]": size === "extra-large",
        capitalize: capitalized,
        [additionalClassname]: additionalClassname
      })}
      onClick={onClick}
      type={type}
      style={computedStyle()}
      disabled={disabled}
    >
      {icon && iconPosition === "left" && (
        <>
          {icon}
        </>
      )}
      {!loading ? label : "Loading..."}
      {icon && iconPosition === "right" && (
        <>
          {icon}
        </>
      )}
    </button>
  );
};

export default Button;
